/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Overage_OffInputs */



/**
* | output |
* | --- |
* | "Pay-per-use after the budget is OFF: once the prepaid budget is used up, requests in the app fall back to the free model and requests through an API key or t..." |
*
* @param {Partner_Org_Contract_Overage_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_overage_off = /** @type {((inputs?: Partner_Org_Contract_Overage_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Overage_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbasierte Abrechnung nach dem Budget ist AUS: Ist das vorausbezahlte Budget verbraucht, weichen Anfragen in der App auf das kostenlose Modell aus und Anfragen über einen API-Schlüssel oder den Microsoft-Teams-Bot werden abgelehnt, bis dem Vertrag Guthaben hinzugefügt wird.")
	return /** @type {LocalizedString} */ ("Pay-per-use after the budget is OFF: once the prepaid budget is used up, requests in the app fall back to the free model and requests through an API key or the Microsoft Teams bot are refused, until credit is added to the contract.")
});